import React from 'react'
import { Box, Flex, Text, Divider } from '@chakra-ui/core'
import { SelectableItem } from './types'
import { CustomCheckBox } from '../GroupsTree/style'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import LocaleText from 'components/LocaleText'

interface Props {
  title: string
  icon?: React.ReactElement
  items: SelectableItem[]
  selectedIds: string[]
  onToggle: (id: string) => void
  showDivider?: boolean
}

export const GroupedSelectGroup: React.FC<Props> = ({ title, icon, items, selectedIds, onToggle, showDivider }) => {
  const theme = useSelector((state: RootState) => state.general.theme)

  return (
    <Box>
      <Flex style={{ gap: '10px', padding: '4px', marginBottom: '5px' }}>
        {icon && <Box as="span">{icon}</Box>}
        <Text fontWeight="bold">
          <LocaleText text={title} />
        </Text>
      </Flex>

      {items.map((item) => (
        <Flex key={item.id} style={{ gap: '10px', padding: '4px' }}>
          <CustomCheckBox
            color={theme?.elementsColor}
            isChecked={selectedIds.includes(item.id)}
            onChange={() => onToggle(item.id)}
          />
          <Text isTruncated maxW="320px">
            <LocaleText text={item.name} />
          </Text>
        </Flex>
      ))}

      {showDivider && <Divider my="2" />}
    </Box>
  )
}
